import * as React from "react"

// @ts-ignore
import {  saBoxes,  saBoxesBlocks,  saBoxesBlocksItem,saBoxesTextContainer,  saBoxesBlocksItemIcon,  saBoxesBlocksItemText,  saBoxesBlocksItemTitle,  saBoxesTitle,  saBoxesTitleContainer } from "./saBoxes2.module.scss"
import { SaTitle } from "../saTitle/saTitle"
import SaSwitchIcons from "../saSwitchIcons/saSwitchIcons"
import { saInterfacesBoxes2 } from "../saTypes"


export const SaBoxes2: React.FC<saInterfacesBoxes2> = ({ ...props }) =>  {

    //console.log(props.blocks)

    let gridDesk: string = ' gridDesk-5'
    let gridTab: string = ' gridTab-4'
    let gridMob: string = ' gridMob-2'

    if (props.gridDesk){
      gridDesk = ' gridDesk-' + props.gridDesk
    }

    if (props.gridTab){
      gridTab = ' gridTab-' + props.gridTab
    }

    if (props.gridMob){
      gridMob = ' gridMob-' + props.gridMob
    }


    let list = props.blocks

    let listItems = list?.map((item ,index)  => (
        <div key={index} className={saBoxesBlocksItem}>

          {
            item.icon && (item.icon !== "null") &&
            <div className={saBoxesBlocksItemIcon}>
              <SaSwitchIcons icon={item.icon} />
            </div>
          }

          {
            item.title &&
            <div className={saBoxesBlocksItemTitle}
                 dangerouslySetInnerHTML={{__html: item.title}}/>
          }

          {
            item.text &&
            <div className={saBoxesBlocksItemText}
                 dangerouslySetInnerHTML={{__html: item.text}}/>
          }

        </div>
      )
    )

    return (
      <div className={'saContainer ' + saBoxes}>

        {
          props.title &&
          <div className={saBoxesTitleContainer}>
            <SaTitle title={props.title} classes={saBoxesTitle}/>
          </div>
        }

        {
          props.text &&
          <div className={saBoxesTextContainer}
               dangerouslySetInnerHTML={{__html: props.text}}/>
        }

        <div className={saBoxesBlocks + gridDesk + gridTab + gridMob}>
          { listItems }
        </div>

      </div>
    )

}
